import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const KAT_RENK: Record<string, string> = { 'Bilgi': '#0d9488', 'Sorun': '#f59e0b', 'Acil': '#ef4444' };
const KAT_RGB: Record<string, string> = { 'Bilgi': '13,148,136', 'Sorun': '245,158,11', 'Acil': '239,68,68' };

@Component({
  selector: 'vardiya-notu-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--vardiya-notu" [style.--accent]="katRenk()" [style.--accent-rgb]="katRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:8s;--x:15%;--y:25%"></span><span class="gc-p" style="--d:10s;--x:72%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:48%;--y:68%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">VARDİYA NOTU</div>
        <div class="vn-ust">
          <div class="vn-kategori-badge">{{ p()?.kategori || 'Bilgi' }}</div>
          @if (p()?.makine) { <div class="vn-makine">{{ p().makine }}</div> }
        </div>
        @if (p()?.baslik) { <div class="vn-baslik gc-baslik-ana">{{ p().baslik }}</div> }
        @if (p()?.aciklama) { <div class="vn-aciklama">{{ p().aciklama }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 40 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #0d9488; --accent-rgb: 13,148,136; }
    .vn-ust { display: flex; align-items: center; gap: 8px; }
    .vn-kategori-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); flex-shrink: 0; animation: badge-pulse 2s ease-in-out infinite; }
    .vn-makine { font-size: 9px; font-weight: 600; color: var(--py-metin-ikincil, #64748b); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .vn-baslik { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .vn-aciklama { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  `],
})
export class VardiyaNotuKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  katRenk = computed(() => KAT_RENK[this.p()?.kategori] || '#0d9488');
  katRgb = computed(() => KAT_RGB[this.p()?.kategori] || '13,148,136');
}
